import * as React from 'react';

import type {
    GetPlanComparisons_planComparisons_featureGroups,
    GetPlanComparisons_planComparisons_featureGroups_features as Feature,
} from 'nutshell-graphql-types';

import {PlanComparisonTableRow} from './plan-comparison-table-row';

import styles from './plan-comparison-table.module.css';

type Props = {
    featureGroup: GetPlanComparisons_planComparisons_featureGroups;
    numPlans: number;
};

const getSpacerKey = (i: number, featureGroupTitle: string) => `spacer-${i}-${featureGroupTitle}`;

// Feature = "Contact management", "Lead capture", etc.
export function FeatureGroup(props: Props): React.ReactElement {
    return (
        <>
            <tr className={styles['table-row--feature-group-header']}>
                <td className={styles['table-cell--feature-group-title']}>
                    {props.featureGroup.title}
                </td>
                {Array(props.numPlans)
                    .fill(null)
                    .map((_, i) => (
                        <td
                            key={getSpacerKey(i, props.featureGroup.title)}
                            className={styles['table-cell--spacer']}
                        ></td>
                    ))}
            </tr>
            {props.featureGroup.features.map((feature: Feature) => {
                return <PlanComparisonTableRow key={feature.name} feature={feature} />;
            })}
        </>
    );
}
